import CollaborationCloseIcon from '@/assets/Icons/components/CollaborationCloseIcon';
import WarningIcon from '@/assets/Icons/components/WarningIcon';
import Button from '@/components/Button/Button';
import { useEffect, useRef, useState } from 'react';
import { UnSavedProgressPopupProps } from './PopupTypes';

const UnSavedProgressPopupNext = ({
  isVisible,
  handleNext,
  onClose,
  handleSaveProgress,
  loading,
}: UnSavedProgressPopupProps) => {
  const [isShowing, setIsShowing] = useState(isVisible);

  const popupRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setIsShowing(isVisible);
  }, [isVisible]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
        onClose();
      }
    };

    // Only add the event listener if the popup is visible
    if (isShowing) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    // Clean up the event listener
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isShowing, onClose]);

  if (!isShowing) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center  justify-center z-50">
      <div ref={popupRef} className="bg-white rounded-lg p-6">
        <div className="flex justify-between items-center">
          <div className="flex gap-2">
            <WarningIcon />
            <span className="text-ds-gray-700 font-semibold">Unsaved Progress</span>
          </div>
          <div onClick={onClose} className="cursor-pointer">
            <CollaborationCloseIcon />
          </div>
        </div>
        <p className="text-ds-gray-500 text-sm py-4">
          Unsaved changes detected. Save your progress to avoid losing any updates.
        </p>
        <div className="flex justify-end gap-2">
          <Button size="xl" color="outlined" onClick={handleNext}>
            Continue without saving
          </Button>
          <Button size="xl" loading={loading} color="success" onClick={handleSaveProgress}>
            Save and continue
          </Button>
        </div>
      </div>
    </div>
  );
};

export default UnSavedProgressPopupNext;
